<template>
    <div id="toast_shadow" v-if="toastIsShow" :class="showAnimateContent ?'fadein':'fadeout'">
        <div class="mask-shadow2"></div>
        <div class="toast-main-one">
            <div class="team-tips">
                <h3 :style="{'padding-top':(toastSubText!==''?'54px':'79px')}">{{toastText}}</h3>
                <p v-if="toastSubText!==''">{{toastSubText}}</p>
            </div>
            <div class="make-sure" v-if="twoBtnFlag">
                <span v-on:click="clickCancel">{{cancelText}}</span>
                <span v-on:click="clickSure">{{sureText}}</span>
            </div>
            <div class="make-one-sure" v-if="!twoBtnFlag" v-on:click="clickIKnow">知道了</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Toast"
    }
</script>

<style scoped>
    #toast_shadow{position: fixed;  width: 580px; height: 276px; top:50%; left:50%; margin-top:-138px; margin-left: -290px; background-color: #FFFFFF; -webkit-border-radius:10px; border-radius:10px; z-index: 8000;}
    .toast-main-one{position: fixed;  width: 580px; height: 276px; top:50%; left:50%; margin-top:-138px; margin-left: -290px; background-color: #FFFFFF; -webkit-border-radius:10px; border-radius:10px; z-index: 8000;}
    .team-tips{text-align: center; }
    .team-tips h3{font-size: 24px;line-height: 33px;}
    .team-tips p{font-size: 20px;line-height: 28px; padding-top: 14px;}
    .make-sure{ position: absolute; width:100%; left:0; bottom: 32px; text-align: center; height: 48px; font-size:0; }
    .make-sure span{ display: inline-block; text-align: center; line-height: 46px; width:160px; margin: 0 20px; border: 1px solid #979797; -webkit-border-radius: 5px;border-radius: 5px; font-size: 14px; color: #999999; cursor: pointer; -webkit-user-select: none; user-select: none; -webkit-box-sizing: border-box; box-sizing: border-box; }
    .make-sure span:last-child{ color: #FFFFFF; background-color: #FE2741; border: 1px solid #FE2741;}
    .make-one-sure{ position: absolute; width:208px; left:50%; margin-left: -104px; bottom: 32px; height:48px; line-height: 48px; font-size: 14px; color: #FFFFFF; background-color: #FE2741; -webkit-border-radius: 5px;border-radius: 5px; -webkit-user-select: none;user-select: none; text-align: center; cursor: pointer;}
    .mask-shadow2{ position: fixed; width:100%; height: 100%; top:0; left:0; right:0; bottom: 0; background-color: rgba(0,0,0,0.6); z-index: 6000; }
    .fadein{animation:animate_in .25s}
    .fadeout{animation:animate_out .25s;opacity:0}
    @keyframes animate_in{0%{opacity:0}
        100%{opacity:1}
    }
    @keyframes animate_out{0%{opacity:1}
        100%{opacity:0}
    }

</style>